(ns frontend.view.printouts.report
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.db :as app-db]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.components.bar-chart :as bar-chart]
   [frontend.view.components.pie-chart :as pie-chart]
   [frontend.view.printouts.db :as db]
   [frontend.view.printouts.events :as events]
   [reagent.core :as r]
   [ui.components.chart.view :as chart]
   [ui.components.button.view :as button]))

(defn controls
  [data]
  (let [start-of-hour (* 3600000 (js/Math.round (/ (.getTime (js/Date.)) 3600000)))]
    [:div.print-controls
     [:select
      {:on-change (fn [e]
                    (events/change! :start-date
                                    (js/parseInt (-> e
                                                     .-target
                                                     .-value))))
       :value     (or (:start-date @db/settings) "")}
      [:option {:key "" :value ""} (loc/tr :select-start-period)]
      (when (->> data
                 :period-options)
        (doall (for [opt (->> data
                              :period-options)]
                 [:option
                  (merge
                   {:key   (:key opt)
                    :value (:start-value opt)}
                   (when (and (not (:start-date @db/settings))
                              (= opt
                                 (->> data
                                      :period-options
                                      (first))))
                     {:selected true}))
                  (:key opt)])))
      (when (session/sys-admin?)
        [:option
         (merge
          {:key   "beginning"
           :value 943920005000}                             ;;Tuesday, November 30, 1999 12:00:05 AM
          (when (= 943920005000 (str (:end-date @db/settings)))
            {:selected true})) "4Q1999"])]
     [:select
      {:on-change (fn [e]
                    (events/change! :end-date
                                    (js/parseInt (-> e
                                                     .-target
                                                     .-value))))
       :value     (or (:end-date @db/settings) "")}
      [:option {:key "" :value ""} (loc/tr :select-end-period)]
      (when (->> data
                 :period-options)
        (doall (for [opt (->> data
                              :period-options)]
                 [:option
                  (merge
                   {:key   (:key opt)
                    :value (:end-value opt)}
                   (when (and (not (:end-date @db/settings))
                              (= opt
                                 (->> data
                                      :period-options
                                      (last))))
                     {:selected true}))
                  (:key opt)])))
      (when (session/sys-admin?)
        [:option
         (merge
          {:key   "now"
           :value start-of-hour}
          (when (= start-of-hour (str (:end-date @db/settings)))
            {:selected true})) "Now"])]
     [button/primary-solid
      {:on-click   events/print!}
      "Print"]
     [button/secondary-hollow
      {:on-click   (fn [e]
                     (.preventDefault e)
                     (.stopPropagation e)
                     (routing/set-view! [:oppos-grid]))
       :class "ms-2"}
      "Exit"]]))

(defn graphs
  [data token]
  (let [industry-tag-count (->> data
                                :deals-per-industry
                                :data
                                (count))
        max-industry-count (->> data
                                :deals-per-industry
                                :data
                                (map :count)
                                (apply max))]
    (if (:printing @db/settings)
      [:div.print-process
       [:div.print-processing
        [:div
         [:i.fal.fa-spinner.fa-pulse.fa-3x]]
        [:div [:span (loc/tr :processing)]]]]
      [:div.printout-page
       (when (= token "preview")
         [controls data])

       [:div.printout-row
        [:h2 "Quarterly deal flow"]
        [chart/view
         (bar-chart/options {:grid-line-color  "#3C3D39"
                             :background-color "#FFFFFF"
                             :labels-color     "#82867B"
                             :series-color     "rgb(72,194,195)"
                             :label-color      "rgb(72,194,195)"
                             :height           200
                             :width            800
                             :legend           false
                             :y-labels         true
                             :y-title          "# Deals"
                             :type             "column"
                             :label            (->> data
                                                    :quarterly-deal-flow
                                                    :title)}
                            (->> (:quarterly-deal-flow data)
                                 :data
                                 (map (fn [d]
                                        (let [[q y] (string/split (:label d) #"Q")]
                                          {:label (str q "Q." (mod (js/parseInt y) 100))
                                           :count (:count d)})))))]]
       [:div.printout-row
        [:h2.pb-2 "Deal distribution"]
        [:div
         {:class-name "grid grid-cols-2 gap-4"}
         (when (some-> data
                       :deals-per-geography
                       :data
                       (first))
           [:div
            [:div
             [chart/view
              (pie-chart/options
               {:size           250
                :height         400
                :width          385
                :label-distance -40
                :start-angle    0
                :end-angle      360
                :label-color    "rgb(72,194,195)"
                :custom-colors  ["rgb(72,194,195)"
                                 "rgb(151,215,218)"
                                 "rgb(220,242,243)"
                                 "rgb(216,216,216)"
                                 "rgb(144,144,144)"
                                 "rgb(0,43,61)"
                                 "rgb(50,100,200)"
                                 "rgb(200,50,100)"
                                 "rgb(100,200,50)"
                                 "rgb(70,124,124)"]
                :label          (->> data
                                     :deals-per-geography
                                     :title)}
               (->> data
                    :deals-per-geography
                    :data))]]])
         (when (some-> data
                       :deals-per-benelux
                       :data
                       (first)
                       (empty?)
                       (not))
           [:div
            [:div
             [chart/view
              (pie-chart/options
               {:size           240
                :height         400
                :width          385
                :label-distance -25
                :start-angle    0
                :end-angle      360
                :label-color    "rgb(72,194,195)"
                :custom-colors  ["rgb(72,194,195)"
                                 "rgb(151,215,218)"
                                 "rgb(220,242,243)"
                                 "rgb(216,216,216)"
                                 "rgb(144,144,144)"
                                 "rgb(0,43,61)"
                                 "rgb(50,100,200)"
                                 "rgb(200,50,100)"
                                 "rgb(100,200,50)"
                                 "rgb(70,124,124)"]
                :label          (->> data
                                     :deals-per-benelux
                                     :title)}
               (->> data
                    :deals-per-benelux
                    :data))]]])]]
       (when (some-> data
                     :deals-per-funding-stage
                     :data
                     (first))
         [:div.printout-row
          [:div
           {:class-name "grid grid-cols-2 gap-4"}
           [:div
            [:div
             [chart/view
              (pie-chart/options
               {:class-name     "blow-out"
                :size           250
                :height         400
                :width          385
                :start-angle    0
                :end-angle      360
                :label-distance -40
                :label-color    "rgb(72,194,195)"
                :custom-colors  ["rgb(72,194,195)"
                                 "rgb(151,215,218)"
                                 "rgb(220,242,243)"
                                 "rgb(216,216,216)"
                                 "rgb(144,144,144)"
                                 "rgb(0,43,61)"
                                 "rgb(50,100,200)"
                                 "rgb(200,50,100)"
                                 "rgb(100,200,50)"
                                 "rgb(70,124,124)"]

                :label          (->> data
                                     :deals-per-funding-stage
                                     :title)}
               (->> data
                    :deals-per-funding-stage
                    :data))]]]
           [:div
            [:div.half]]]])

       [:div.page-break]

       [:div.printout-row
        [:h2.pb-2 "Industry sectors"]
        [:div
         {:class-name "grid gap-4"}
         [:div
          [chart/view
           (bar-chart/options
            {:grid-line-color  "#3C3D39"
             :background-color "#FFFFFF"
             :labels-color     "#82867B"
             :series-color     "rgb(72,194,195)"
             :label-color      "rgb(72,194,195)"
             :height           (+ 80 (* 16 industry-tag-count))
             :width            800
             :type             "bar"
             :legend           false
             :y-labels         true
             :tick-interval    (js/Math.ceil (/ max-industry-count 10))
             :label            (->> data
                                    :deals-per-industry
                                    :title)}
            (->> data
                 :deals-per-industry
                 :data))]]]]

       [:div.printout-row
        [:h2 "Companies short listed in current period"]
        [:table.printout-table
         [:thead
          [:tr
           [:th "Company name"]
           [:th "Website"]
           [:th "Description"]]]
         [:tbody
          (for [company (:companies-short-listed-in-this-quarter data)]
            ^{:key (str "report-comp" (:asset/name company))}
            [:tr
             [:td (:asset/name company)]
             [:td (:company/website company)]
             [:td (:company/company-business-type company)]])]]]
       [:div.printout-row
        [:h2 "Previously short listed companies rejected in current period"]
        [:table.printout-table
         [:thead
          [:tr
           [:th "Company name"]
           [:th "Rejection category"]
           [:th "Description"]]]
         [:tbody
          (for [company (:shortlisted-passed-in-this-quarter data)]
            ^{:key (str "report-comp-passed" (:asset/name company))}
            [:tr
             [:td (:asset/name company)]
             [:td (:oppo/pass-reason-v2 company)]
             [:td (:company/company-business-type company)]])]]]
       [:div.printout-background-bottom
        [:img {:src "/img/print-blue-bg.png"}]]
       [:div.printout-background-top
        [:img {:src "/img/print-gray-bg.png"}]]
       [:div.printout-footer
        (when (->> data
                   :report-logo)
          [:div.printout-logo
           [:img
            {:src (fu/sanitize-img-url (->> data
                                            :report-logo))}]])]])))

(defn view
  [report token start-date end-date]
  (swap! app-db/app-state assoc-in
    [:views :printouts :settings]
    {:token      token
     :report     report
     :start-date (or start-date)
     :end-date   (or end-date)})
  (events/fetch-data!)
  (r/create-class
   {:reagent-render
    (fn [_]
      [:div
       {:class-name (fu/cs "printout"
                           (when (some->> @db/state
                                          :deals-per-geography
                                          :title)
                             "page_printable"))}
       (if db/state
         [graphs @db/state token]
         "not loaded")])}))

(defmethod routing/render-view :reports-printout
  [{:keys [route-params]}]
  (let [report (:report route-params)
        token (:token route-params)
        start-date (:start-date route-params)
        end-date (:end-date route-params)
        start-date (if (< (count start-date) 5) nil (js/parseInt start-date))
        end-date (if (< (count end-date) 5) nil (js/parseInt end-date))]
    [view report token start-date end-date]))
